import { Badge, Button, Checkbox, Menu, Stack } from '@mantine/core';
import { IconPaperclip } from '@tabler/icons-react';
import { i18nKeys, useTranslation } from 'locales';
import type { TemplateV2 } from 'shared/hooks/use-load-template-v2';
import { useUpdateTemplate } from '../api';
import { useActiveChannelAtom } from './state';

type AttachmentsSelectorProps = {
  template: TemplateV2;
};

export const AttachmentsSelector = ({ template }: AttachmentsSelectorProps) => {
  const { t } = useTranslation();
  const [activeChannel] = useActiveChannelAtom();
  const { updateTemplate, isUpdateTemplateLoading } = useUpdateTemplate();

  const canAttachDocuments =
    activeChannel === 'email' && STEP_TYPES_WITH_ATTACHMENTS.includes(template.stepType);
  if (!canAttachDocuments) return null;

  const attachmentCount = Number(template.includePDF) + Number(template.includeUbl);

  return (
    <Menu position="bottom" withArrow closeOnItemClick={false} withinPortal>
      <Menu.Target>
        <Button
          variant="default"
          size="xs"
          leftSection={<IconPaperclip size={16} stroke={1.5} />}
          rightSection={
            attachmentCount > 0 ? (
              <Badge size="sm" circle>
                {attachmentCount}
              </Badge>
            ) : null
          }
        >
          {t(i18nKeys.TEMPLATE.ATTACHMENTS)}
        </Button>
      </Menu.Target>
      <Menu.Dropdown>
        <Stack gap="sm" p="xs">
          <Checkbox
            label="PDF"
            checked={template.includePDF}
            disabled={isUpdateTemplateLoading}
            onChange={event =>
              updateTemplate({ id: template.id, includePDF: event.currentTarget.checked })
            }
          />
          <Checkbox
            label="UBL"
            checked={template.includeUbl}
            disabled={isUpdateTemplateLoading}
            onChange={event =>
              updateTemplate({ id: template.id, includeUbl: event.currentTarget.checked })
            }
          />
        </Stack>
      </Menu.Dropdown>
    </Menu>
  );
};

const STEP_TYPES_WITH_ATTACHMENTS = ['invoice', 'credit_note'];
